import { Inject, PLATFORM_ID, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { of, Subject, Subscription } from 'rxjs';
import { GENERATOR_ENV_TOKEN, GeneratorEnv } from 'src/app/web-generator/generator-env-token';
import { Section } from 'src/app/web-generator/template-generator/entity/section';
import { SECTION_DATA } from '../../service/section-data';
import { AbstractIndexCustom } from '../index-custom/abstract-index-custom';
import { debounceTime, distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import { CommonHttpClientService } from 'src/app/share/service/common-http-client.service';
import { ServerConfigService } from 'src/app/share/service/server-config.service';
import { AutoCompleteOptionsComponent } from 'src/app/share/component/auto-complete-options/auto-complete-options.component';
import { HotKeywordsService } from 'src/app/share/service/hot-keywords.service';
import { isPlatformBrowser } from '@angular/common';
import { TemplateService } from 'src/app/web-generator/template-generator/service/template.service';
import { TranslateService } from '@ngx-translate/core';

export abstract class AbstractIndexSearch extends AbstractIndexCustom implements OnInit, OnDestroy {
  @ViewChild('skACO', {static: false}) skACO: AutoCompleteOptionsComponent;
  /** 到首頁的路徑 */
  toHomePath: string;
  /** 是瀏覽器端渲染 */
  isBrowser: boolean;
  /** 查詢關鍵字 */
  searchKeyword: string;
  /** 關鍵字變化通知器 */
  protected searchKeyword$ = new Subject<string>();
  /** 關鍵字檢索選項 */
  keywordsOptions: string[] = [];
  /** 關鍵字檢索訂閱 */
  private filterOptionSubc: Subscription;
  remoteData: any = {};

  constructor(
    @Inject(SECTION_DATA) protected section: Section,
    @Inject(GENERATOR_ENV_TOKEN) protected generatorEnv: GeneratorEnv,
    @Inject(PLATFORM_ID) protected platformId: object,
    protected serverConfigService: ServerConfigService,
    protected router: Router,
    protected route: ActivatedRoute,
    protected http: CommonHttpClientService,
    protected hotKeywordsService: HotKeywordsService,
    protected templateService: TemplateService,
    protected translate: TranslateService,
  ) {
    super(section, generatorEnv, platformId, serverConfigService, templateService, translate);
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.toHomePath = `/${translate.currentLang}`;
  }

  ngOnInit() {
    this.hotKeywordsService.hotKeyWords$.subscribe(hotKeyWords => {
      Object.assign(this.remoteData, {topKeywords: hotKeyWords} as any);
    });

    this.serverConfigService.getConfig$().subscribe(siteInfo => {
      this.remoteData.total = siteInfo.total;
    });

    if (this.isBrowser) {
      this.filterOptionSubc = this.searchKeyword$.pipe(
        debounceTime(500),
        distinctUntilChanged(),
        switchMap(value => {
          if (value) {
            value = value.trim();
            const body = new URLSearchParams();
            body.set('top', '10');
            if (value) { body.set('q', value); }
            return this.http.post<{ input: string; output: {[key: string]: number}[]; }>(`${this.generatorEnv.itriAutoCompleteApiHost}/v2/autocomplete`, body.toString(), {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
              }
            });
            // return of(( { input: value, output: [{'戰爭館': 12}, {"第二次世界大戰": 50}]} as { input: string; output: {[key: string]: number}[]; } ));
          } else {
            return of(( { input: value, output: []} as { input: string; output: {[key: string]: number}[]; } ));
          }
        }),
        map(v => {
          return v.output.map(v2 => Object.keys(v2)[0]);
        }),
      ).subscribe(options => {
        this.keywordsOptions = options;
      });
    }
  }

  ngOnDestroy(): void {
    if (this.filterOptionSubc) {
      this.filterOptionSubc.unsubscribe();
      delete this.filterOptionSubc;
    }
  }

  /** 當關鍵字詞改變 */
  onKeywordChange(value: string) {
    this.searchKeyword$.next(value);
  }

  /** 當關鍵字輸入框聚焦 */
  onFocusSearchKeywordInput() {
    this.skACO.isShowOptions = true;
  }

  /** 當點擊畫面上的按鈕做查詢(只針對分類和關鍵字) */
  onClickSearch(e?: UIEvent) {
    if (e) { e.preventDefault(); }
    if (this.searchKeyword) {
      this.router.navigate([`${this.toHomePath}/datasearch`], {
        queryParams: { keyword: this.searchKeyword },
        queryParamsHandling: 'merge',
      });
    }
  }
}
